import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { useLogoDesign } from "@/hooks/useLogoDesign";

export default function Footer() {
  const logoDesign = useLogoDesign();
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white mt-32">
      <div className="ermine-strip h-6 border-b border-white/10" aria-hidden />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-5 gap-10">
        <div className="md:col-span-1">
          <Logo design={logoDesign} theme="light" size={42} />
          <p className="mt-6 text-sm text-neutral-400 leading-relaxed">
            Le seul site de location 100% breton.<br />Kenavo Airbnb.
          </p>
          <div className="mt-6 text-xs text-neutral-400">
            <div className="text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-2">Support 8h–23h</div>
            <a href="tel:+33972158090" className="font-display text-lg font-bold text-white hover:text-[#C9986A]">09 72 15 80 90</a>
            <div className="mt-1">Beaussais-Sur-Mer (22)</div>
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-neutral-500 mb-4">Régions</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/search?region=Finistère" className="hover:text-[#C9986A]">Finistère</Link></li>
            <li><Link to="/search?region=Côtes-d'Armor" className="hover:text-[#C9986A]">Côtes-d'Armor</Link></li>
            <li><Link to="/search?region=Morbihan" className="hover:text-[#C9986A]">Morbihan</Link></li>
            <li><Link to="/search?region=Ille-et-Vilaine" className="hover:text-[#C9986A]">Ille-et-Vilaine</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-neutral-500 mb-4">Propriétaires</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/become-host" className="hover:text-[#C9986A]">Mettre en location</Link></li>
            <li><Link to="/owner" className="hover:text-[#C9986A]">Espace propriétaire</Link></li>
            <li><Link to="/partenaires" className="hover:text-[#C9986A]">Trouver un partenaire</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-neutral-500 mb-4">Voyageurs</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/search" className="hover:text-[#C9986A]">Rechercher</Link></li>
            <li><Link to="/traveler" className="hover:text-[#C9986A]">Mes réservations</Link></li>
            <li><Link to="/messages" className="hover:text-[#C9986A]">Messagerie</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-neutral-500 mb-4">Partenaires & aide</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/devenir-partenaire" className="hover:text-[#C9986A]">Devenir partenaire</Link></li>
            <li><Link to="/conciergerie" className="hover:text-[#C9986A]">Espace conciergerie</Link></li>
            <li><Link to="/partenaires" className="hover:text-[#C9986A]">Conciergeries & ménage</Link></li>
            <li><Link to="/ressources" className="hover:text-[#C9986A]">Ressources hôtes</Link></li>
            <li><Link to="/support" className="hover:text-[#C9986A]">Support & contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-neutral-500">
          <div>© {new Date().getFullYear()} Mon Séjour en Bretagne — Tous droits réservés</div>
          <div className="uppercase tracking-[0.25em]">Bevet Breizh 🏴</div>
        </div>
      </div>
    </footer>
  );
}
